import { render, staticRenderFns } from "./SplashNews.vue?vue&type=template&id=7b041e1c&scoped=true"
import script from "./SplashNews.vue?vue&type=script&lang=js"
export * from "./SplashNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b041e1c",
  null
  
)

export default component.exports